import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = {
  class: "button-text"
};
const _hoisted_2 = {
  class: "button-price"
};
const _hoisted_3 = {
  class: "symbol"
};
const _hoisted_4 = {
  class: "integer"
};
const _hoisted_5 = {
  class: "decimal"
};
import { onMounted, ref, watch, computed } from 'vue';
import { useRoute } from 'vue-router';
import { useI18n } from 'vue-i18n';
import { priceSplice } from '@/utils/common';
import { findOptimalPromotion } from '@/views/spc/orderConfirm/components/SPCAccountingBox.js';
export default {
  __name: 'BuyNow',
  props: {
    isAddToCart: {
      type: Boolean
    },
    showBtn: {
      type: String
    },
    promotionInfoList: {
      type: Array,
      default: () => []
    },
    asinDetails: {
      type: Object,
      default: () => ({
        ourPrice: {
          amount: ''
        }
      })
    }
  },
  emits: ['onAddCart', 'onPaying'],
  setup(__props, {
    emit
  }) {
    const props = __props;
    const {
      t
    } = useI18n();
    const isCartPageUse = ref(false);
    const promotions = ref(null);
    const promotionsList = ref([]);
    const route = useRoute();
    onMounted(() => {
      // If it is a shopping cart, change the bottom style
      if (route.name === 'cart') {
        isCartPageUse.value = true;
      }
    });
    const postCouponPrice = computed(() => {
      var _promotions$value, _props$asinDetails$ou;
      if (!((_promotions$value = promotions.value) !== null && _promotions$value !== void 0 && _promotions$value.amount)) return (_props$asinDetails$ou = props.asinDetails.ourPrice) === null || _props$asinDetails$ou === void 0 ? void 0 : _props$asinDetails$ou.amount;
      return props.asinDetails.ourPrice.amount - promotions.value.amount;
    });
    const buyText = computed(() => {
      var _promotions$value2;
      return (_promotions$value2 = promotions.value) !== null && _promotions$value2 !== void 0 && _promotions$value2.amount ? t('modules.checkout.PURCHASE_CLAIM_THE_COUPON') : t('modules.checkout.PURCHASE_IMMEDIATELY');
    });
    const findPromotions = () => {
      var _props$asinDetails$ou2;
      promotions.value = findOptimalPromotion(promotionsList.value, Number((_props$asinDetails$ou2 = props.asinDetails.ourPrice) === null || _props$asinDetails$ou2 === void 0 ? void 0 : _props$asinDetails$ou2.amount));
    };
    watch(() => props.promotionInfoList, value => {
      if (value) {
        promotionsList.value = value.map(item => {
          return {
            amount: item.benefitsAmount,
            id: item.id,
            text: item.text,
            threshold: item.thresholdAmount
          };
        });
        findPromotions();
      }
    }, {
      immediate: true
    });
    watch(() => {
      var _props$asinDetails, _props$asinDetails$ou3;
      return (_props$asinDetails = props.asinDetails) === null || _props$asinDetails === void 0 ? void 0 : (_props$asinDetails$ou3 = _props$asinDetails.ourPrice) === null || _props$asinDetails$ou3 === void 0 ? void 0 : _props$asinDetails$ou3.amount;
    }, newAmount => {
      if (newAmount) findPromotions();
    });
    const onConfirm = async () => {
      // The method is called according to the field judgment
      if (props.isAddToCart) {
        emit('onAddCart');
      } else {
        // Confirmation state todo
        emit('onPaying');
      }
    };
    return (_ctx, _cache) => {
      const _component_van_button = _resolveComponent("van-button");
      return _openBlock(), _createElementBlock("div", {
        class: _normalizeClass(["button-group", {
          bar: isCartPageUse.value,
          '-two': __props.showBtn === 'doubleBtn'
        }])
      }, [__props.showBtn == 'doubleBtn' ? (_openBlock(), _createElementBlock(_Fragment, {
        key: 0
      }, [_createElementVNode("button", {
        class: "button -confirm",
        onClick: _cache[0] || (_cache[0] = () => emit('onAddCart'))
      }, _toDisplayString(_unref(t)('common.ADD_TO_CART')), 1), _createVNode(_component_van_button, {
        round: "",
        class: "buy-button",
        onClick: _cache[1] || (_cache[1] = () => emit('onPaying'))
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_1, _toDisplayString(buyText.value), 1), _createElementVNode("div", _hoisted_2, [_createElementVNode("span", _hoisted_3, _toDisplayString(_unref(t)('common.currencyUnit')), 1), _createElementVNode("span", _hoisted_4, _toDisplayString(_unref(priceSplice)(postCouponPrice.value)[0]), 1), _createElementVNode("span", _hoisted_5, "." + _toDisplayString(_unref(priceSplice)(postCouponPrice.value)[1]), 1)])]),
        _: 1
      })], 64)) : (_openBlock(), _createElementBlock("button", {
        key: 1,
        class: "button -large -primary",
        onClick: onConfirm
      }, _toDisplayString(_unref(t)('button.CONFIRM')), 1))], 2);
    };
  }
};